// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1yqqt","list":"_3nD0_"};